import { axiosClient } from '@nx-frontend/shared/api';
import { BoardDTO } from '@nx-frontend/shared/types';

interface GetKanbanParams {
  gatewayUrl: string;
  kanbanId: string;
  sessionId: string;
}

export async function getKanbanById({ kanbanId, sessionId, gatewayUrl }: GetKanbanParams): Promise<BoardDTO | null> {
  try {
    const response = await axiosClient.get<BoardDTO>(`${gatewayUrl}/ft:tasks/boards/${kanbanId}`, {
      headers: {
        'Content-Type': 'application/json',
        'everhelper-session-id': sessionId,
      },
    });
    return response.data;
  } catch (err) {
    console.error('Fail to get kanban by ', kanbanId, ' id');
  }
  return null;
}
